import Swiper from "swiper";
import { A11y, Autoplay } from "swiper/modules";

function getLogoCarousels(scope) {
  const sliders = [];

  if (scope instanceof Element && scope.matches("[data-logo-carousel]")) {
    sliders.push(scope);
  }

  if (scope.querySelectorAll) {
    sliders.push(...scope.querySelectorAll("[data-logo-carousel]"));
  }

  return sliders;
}

function initLogoCarousels(scope = document) {
  getLogoCarousels(scope).forEach((slider) => {
    if (slider.swiper && !slider.swiper.destroyed) {
      slider.swiper.update();
      return;
    }

    const slideCount = slider.querySelectorAll(".swiper-slide").length;

    if (!slideCount) {
      return;
    }

    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    new Swiper(slider, {
      modules: [A11y, Autoplay],
      slidesPerView: 2,
      spaceBetween: 32,
      speed: reducedMotion ? 0 : 700,
      loop: slideCount > 8,
      rewind: slideCount <= 8,
      watchOverflow: true,
      centerInsufficientSlides: true,
      grabCursor: slideCount > 2,
      observer: true,
      observeParents: true,
      autoplay: reducedMotion
        ? false
        : {
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
      a11y: {
        enabled: true,
        containerMessage: "Airline logos carousel",
        itemRoleDescriptionMessage: "Logo slide",
      },
      breakpoints: {
        480: {
          slidesPerView: 3,
          spaceBetween: 36,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        992: {
          slidesPerView: 5,
          spaceBetween: 44,
        },
        1200: {
          slidesPerView: 7,
          spaceBetween: 48,
        },
        1400: {
          slidesPerView: 8,
          spaceBetween: 48,
        },
      },
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initLogoCarousels());
} else {
  initLogoCarousels();
}

document.addEventListener("blockEditorInit", (event) => {
  initLogoCarousels(event.detail?.block || event.target);
});
